import AccountContext from 'context/AccountContext';
import { useContext, useMemo } from 'react';

export const usePoolingGroupData = (permitId: string, uid: string) => {
  const {
    customer: { permits },
  } = useContext(AccountContext);
  const permit = permits?.find((permit) => permit.id === permitId);

  return useMemo(
    () => ({
      poolingGroup: permit?.accessPermitPoolingGroupInfo?.find(
        (group) => group?.uid === uid
      ),
    }),
    [permit, uid]
  );
};
